module.exports = __webpack_public_path__ + "static/media/flow-monitor-action-alert.f51e3685.svg";